import React from 'react';
import { motion } from 'framer-motion';
import {heroReveal} from "../animations/animations";

const CheckoutHeroBit = () => {
    return (
        <motion.div
            variants={heroReveal}
            initial="initial"
            animate="animate"
            className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-pearl via-pearl to-nude/30 md:p-12 mb-2 md:mb-12 pt-12 lg:pt-12"
        >
            {/* Position responsive wrapper - only changes position/padding */}
            <div className="relative pt-6 pb-12 px-4 md:pt-8 md:pb-16 lg:pt-12 lg:pb-20 lg:px-8">
                {/* Subtle Pattern */}
                <div className="absolute inset-0 opacity-5">
                    <div className="absolute inset-0" style={{
                        backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='90' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%239CAF96' fill-opacity='0.1' fill-rule='evenodd'/%3E%3C/svg%3E")`,
                        backgroundSize: '100px 100px'
                    }} />
                </div>

                <div className="relative z-10">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.1, duration: 0.8 }}
                        className="flex items-center gap-3 mb-4 md:mb-6"
                    >
                        <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-gradient-to-br from-champagne/20 to-sage/20 flex items-center justify-center">
                            <svg className="w-5 h-5 md:w-6 md:h-6 text-champagne" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
                            </svg>
                        </div>
                        <span className="text-xs md:text-sm text-charcoal/40 uppercase tracking-wider">Checkout</span>
                    </motion.div>

                    <motion.h1
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.2, duration: 0.8 }}
                        className="font-heading text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-light mb-4 md:mb-6 text-charcoal"
                    >
                        Complete your
                        <br className="hidden sm:block" />
                        KROMAIC ritual
                    </motion.h1>

                    <motion.p
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.3, duration: 0.8 }}
                        className="text-charcoal/60 text-base md:text-lg lg:text-xl max-w-2xl"
                    >
                        Secure checkout • 30-day returns • Free shipping over $100
                    </motion.p>
                </div>

                {/* Floating Elements with responsive positioning */}
                <motion.div
                    animate={{ rotate: 360 }}
                    transition={{ duration: 60, repeat: Infinity, ease: "linear" }}
                    className="absolute right-4 top-4 w-12 h-12 md:right-8 md:top-8 md:w-16 md:h-16 opacity-5"
                >
                    <svg viewBox="0 0 100 100" className="w-full h-full text-sage">
                        <circle cx="50" cy="50" r="40" stroke="currentColor" strokeWidth="1" fill="none" />
                    </svg>
                </motion.div>
            </div>
        </motion.div>
    );
};

export default CheckoutHeroBit;